import { render, staticRenderFns } from "./CompanyModal.vue?vue&type=template&id=53176789"
import script from "./CompanyModal.vue?vue&type=script&lang=js"
export * from "./CompanyModal.vue?vue&type=script&lang=js"
import style0 from "./CompanyModal.vue?vue&type=style&index=0&id=53176789&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports